import React from 'react'
import './about.css'
import ME from '../../assets/me-about.jpeg'
import {FaAward, FaGraduationCap, FaCode, FaLocationArrow, FaQuoteLeft} from 'react-icons/fa'
import {FiUsers, FiDownload, FiMail, FiCalendar} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'
import {MdSchool, MdWork} from 'react-icons/md'

const About = () => {
  return (
    <section id='about'>
      <div className="about__header">
        <span className="about__badge">About Me</span>
        <h2 className="about__main-title">Who Am I?</h2>
        <p className="about__subtitle">Passionate developer crafting digital experiences</p>
      </div>

      <div className="container about__container">
        <div className="about__left">
          <div className="about__profile-card">
            <div className="profile__image-container">
              <img src={ME} alt="Almustapha Mahmud Sulaiman" className="profile__image" />
              <div className="profile__status">
                <div className="status__dot"></div>
                <span>Available for work</span>
              </div>
            </div>
            
            <div className="profile__info">
              <h3 className="profile__name">Almustapha Mahmud Sulaiman</h3>
              <p className="profile__role">MSc Cloud Computing Graduate & Full Stack Developer</p>
              
              <div className="profile__details">
                <div className="detail__item">
                  <MdSchool className="detail__icon" />
                  <span>University of Leicester</span>
                </div>
                <div className="detail__item">
                  <FaLocationArrow className="detail__icon" />
                  <span>Leicester, UK</span>
                </div>
                <div className="detail__item">
                  <FiCalendar className="detail__icon" />
                  <span>MSc Graduate 2025</span>
                </div>
              </div>

              <div className="profile__actions">
                <a href="#contact" className="btn btn-primary">
                  <FiMail />
                  Get In Touch
                </a>
                <a href="/cv.pdf" download className="btn btn-outline">
                  <FiDownload />
                  Download CV
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="about__right">
          <div className="about__story">
            <div className="story__quote">
              <FaQuoteLeft className="quote__icon" />
              <blockquote>
                "I developed my love for technology at a young age, which led me to pursue this exciting field of Computer Engineering."
              </blockquote>
            </div>

            <div className="story__content">
              <p>
                Hello! I'm <strong>Almustapha Mahmud Sulaiman</strong>, a passionate Full Stack Developer 
                and recent <strong>MSc Cloud Computing graduate</strong> from the <strong>University of Leicester</strong>. 
                With a solid foundation in Computer Science Engineering from the University of Debrecen, 
                I bring both theoretical knowledge and practical experience to every project.
              </p>
              
              <p>
                My professional journey includes valuable experience as a <strong>Computer Lab Assistant</strong> at the 
                University of Leicester and as a <strong>Full Stack Developer</strong> at Movolytics, where I've 
                honed my skills in software development, database management, and creating efficient, 
                scalable solutions. I specialize in cloud technologies, full-stack development, and 
                delivering high-quality software that makes a real impact.
              </p>
            </div>
          </div>

          <div className="about__metrics">
            <div className="metric__card">
              <div className="metric__icon-wrapper">
                <FaAward className="metric__icon" />
              </div>
              <div className="metric__content">
                <h4>3+</h4>
                <p>Years Experience</p>
              </div>
            </div>

            <div className="metric__card">
              <div className="metric__icon-wrapper">
                <VscFolderLibrary className="metric__icon" />
              </div>
              <div className="metric__content">
                <h4>25+</h4>
                <p>Projects Completed</p>
              </div>
            </div>

            <div className="metric__card">
              <div className="metric__icon-wrapper">
                <FiUsers className="metric__icon" />
              </div>
              <div className="metric__content">
                <h4>8+</h4>
                <p>Certifications</p>
              </div>
            </div>
          </div>

          <div className="about__specialties">
            <h3>What I Do Best</h3>
            <div className="specialties__grid">
              <div className="specialty__item">
                <div className="specialty__icon">
                  <FaCode />
                </div>
                <div className="specialty__content">
                  <h4>Full-Stack Development</h4>
                  <p>Building complete web applications with modern technologies and cloud integration</p>
                </div>
              </div>

              <div className="specialty__item">
                <div className="specialty__icon">
                  <MdWork />
                </div>
                <div className="specialty__content">
                  <h4>Cloud Computing</h4>
                  <p>Designing scalable cloud solutions with Azure and modern DevOps practices</p>
                </div>
              </div>

              <div className="specialty__item">
                <div className="specialty__icon">
                  <FaGraduationCap />
                </div>
                <div className="specialty__content">
                  <h4>Teaching & Mentoring</h4>
                  <p>Sharing knowledge through lab assistance and collaborative learning environments</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About